import FiscalDocTypeCodeEnum from '@/api/Enums/FiscalDocTypeCodeEnum.js'
import FiscalDocTypeEnum from '@/api/Enums/FiscalDocTypeEnum.js'

export default {

  Language: {
    el: {
      id      : 12,
      active  : true,
      web     : true,
      pos     : true,
      name    : 'Greek',
      locale  : 'el',
      code    : 'el-GR',
      code2   : 'el_GR',
      imageUrl: 'https://cdn.getfood.pro/flags/1x1/el.svg'
    },
    en: {
      id      : 11,
      active  : true,
      web     : true,
      pos     : true,
      name    : 'English',
      locale  : 'en',
      code    : 'en-US',
      code2   : 'en_US',
      imageUrl: 'https://cdn.getfood.pro/flags/1x1/gb.svg'
    },
    bg: {
      id      : 13,
      active  : true,
      web     : false,
      pos     : false,
      name    : 'Bulgarian',
      locale  : 'bg',
      code    : 'bg-BG',
      code2   : 'bg_BG',
      imageUrl: 'https://cdn.getfood.pro/flags/1x1/bg.svg'
    },
    fr: {
      id      : 14,
      active  : true,
      web     : false,
      pos     : false,
      name    : 'French',
      locale  : 'fr',
      code    : 'fr-FR',
      code2   : 'fr_FR',
      imageUrl: 'https://cdn.getfood.pro/flags/1x1/fr.svg'
    }
  },

  Date: {
    Title      : 'Date',
    DateShort  : 'Date',
    Time       : 'Time',
    Hour       : 'Time',
    Minute     : 'Minutes | Minute | Minutes',
    Today      : 'Today',
    Tomorrow   : 'Tomorrow',
    Day        : 'Day',
    Week       : 'Week',
    Month      : 'Month',
    ThreeMonths: '3 Months',
    SixMonths  : '6 Months',
    Year       : 'Year',
    Period     : 'Period',
    PeriodFrom : 'From',
    PeriodTo   : 'To',
    WeekDays   : {
      Short: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
      Long : ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
    },
    Now             : 'Now',
    WithOpenHours   : 'Open Hours Based',
    WithoutOpenHours: 'Calendar Based'
  },

  Update: {
    Cloud: {
      Title          : 'New version available',
      BodyWithVersion: 'There is a system update available. Press "UPDATE NOW" to proceed and switch from version v{CurrentVersion} to the new version v{ServerVersion}.',
      BodyNoVersion  : 'There is a system update available. Press "UPDATE NOW" to proceed and switch to the new version.'
    }
  },

  Button: {
    All                      : 'All',
    Select                   : 'Select',
    PaymentAll               : 'Pay All',
    Notify                   : 'Notify',
    NotifyCollect            : 'Ειδοποίηση Παραλαβής',
    NotifyStatus             : 'Ειδοποίηση Κατάστασης',
    NotifyCustomer           : 'Notify Customer',
    Transactions             : 'Transactions',
    PaymentWith              : 'Pay with',
    Backup                   : 'Backup',
    Upgrade                  : 'Upgrade',
    Downgrade                : 'Downgrade',
    ChangePlan               : 'Change Plan',
    ChangePayment            : 'Change',
    CurrentPlan              : 'Current Plan',
    RenewPlan                : 'Renew Subscription',
    Retry                    : 'Retry',
    RetryOnce                : 'Retry Once',
    RetryAll                 : 'Retry All',
    More                     : 'More',
    Less                     : 'Less',
    Save                     : 'Save',
    Cancel                   : 'Cancel',
    CancelWithRefund         : 'Cancel & Refund',
    Close                    : 'Close',
    Duplicate                : 'Duplicate',
    Delete                   : 'Delete',
    Update                   : 'Update',
    History                  : 'History',
    ReportHistory            : 'Reports History',
    Send                     : 'Send',
    EmailSend                : 'Send by Email',
    EmailSendPdf             : 'Send PDF by Email',
    EmailSendExcel           : 'Send Excel by Email',
    MessageSend              : 'Send by Message',
    Here                     : 'Here',
    Translate                : 'Translate',
    TranslateAll             : 'Translate All',
    Yes                      : 'Yes',
    No                       : 'No',
    Ok                       : 'Ok',
    Accept                   : 'Accept',
    Next                     : 'Next',
    Previous                 : 'Previous',
    Back                     : 'Back',
    Dismiss                  : 'Dismiss',
    View                     : 'View',
    Add                      : 'Add',
    Remove                   : 'Remove',
    Clear                    : 'Clear',
    Reset                    : 'Reset',
    End                      : 'End',
    Finish                   : 'Finish',
    Preview                  : 'Preview',
    Renew                    : 'Renew',
    Copy                     : 'Copy',
    Edit                     : 'Edit',
    Move                     : 'Move',
    MoveSelected             : 'Move Selected',
    MoveAll                  : 'Move All',
    Reports                  : 'Reports',
    Download                 : 'Download',
    Print                    : 'Print',
    PrintOrder               : 'Print Order',
    PrintOrderMarketing      : 'Print Marketing',
    PrintPreparation         : 'Print Preparation',
    PrintReceipt             : 'Print Receipt',
    PrintReceipts            : 'Print Receipts',
    PrintInvoice             : 'Print Invoice',
    PrintFiscalDoc           : 'Print Fiscal Document',
    PrintFnb                 : 'Print Order Document',
    ViewDocument             : 'View Fiscal Document',
    PrintDocument            : 'Print Fiscal Document',
    RetryDocument            : 'Transmit Fiscal Document',
    EmailDocument            : 'Email Fiscal Document',
    CancelReceipt            : 'Cancel Receipt',
    CancelFiscalDoc          : 'Cancel Fiscal Document',
    ConvertReceipt           : 'Convert to Invoice',
    CancelInvoice            : 'Cancel Invoice',
    CancelFnb                : 'Cancel Order Document',
    UpdatePaymentMethods     : 'Update Payment Methods',
    ManageDocuments          : 'Manage Documents',
    ManageDocument           : 'Manage Document',
    ManageReceipt            : 'Manage Receipt',
    ManageInvoice            : 'Manage Invoice',
    ManageFnb                : 'Manage Order Document',
    EmailReceipt             : 'Email Receipt',
    EmailInvoice             : 'Email Invoice',
    EmailFnb                 : 'Email Order Document',
    ViewReceipt              : 'View Receipt',
    ViewInvoice              : 'View Invoice',
    ViewFiscalDoc            : 'View Fiscal Document',
    ViewFnb                  : 'View Order Document',
    IssueDocument            : 'Issue Fiscal Document',
    IssueReceipt             : 'Issue Receipt',
    IssueReceipts            : 'Issue Receipts',
    IssueReceiptSale         : 'Issue Sale Receipt',
    IssueReceiptService      : 'Issue Service Receipt',
    IssueReceiptCollection   : 'Issue Payment Collection Receipt',
    IssueReceiptSelfSupply   : 'Issue Self Supply Document',
    IssueReceiptSelfUse      : 'Issue Self Use Document',
    IssueInvoice             : 'Issue Invoice',
    IssueInvoiceSale         : 'Issue Sale Invoice',
    IssueInvoiceService      : 'Issue Service Invoice',
    IssueFnb                 : 'Issue Order Document',
    ExternalReceipt          : 'External Receipt',
    Payment                  : 'Payment',
    TransactionAdd           : 'Add Transaction',
    TransactionSplitPersonAdd: 'Add Transaction per Person',
    Left                     : 'Left',
    Right                    : 'Right',
    Toggle                   : {
      Active    : 'Active',
      ActiveF   : '@:Common.Button.Toggle.Active',
      ActiveM   : '@:Common.Button.Toggle.Active',
      Inactive  : 'Inactive',
      InactiveF : '@:Common.Button.Toggle.Inactive',
      InactiveM : '@:Common.Button.Toggle.Inactive',
      Horizontal: 'Horizontal',
      Vertical  : 'Vertical',
      Locked    : 'Locked',
      Unlocked  : 'Unlocked',
      Visible   : 'Visible',
      Hidden    : 'Hidden'
    },
    Import: {
      Icon : 'file_upload',
      Title: 'Import'
    },
    Export: {
      Icon : 'file_download',
      Title: 'Export'
    }
  },

  Misc: {
    Desc          : 'Desc',
    Printer       : 'Printers | Printer | Printers',
    Total         : 'Total',
    Change        : 'Change',
    Payment       : 'Payment',
    Subtotal      : 'Subtotal',
    PricePerPerson: 'Cost / Person',
    Person        : 'Person',
    Name          : 'Name',
    Discount      : 'Discount',
    Discounts     : 'Discounts',
    ExtraCharges  : 'Charge',
    Balance       : 'Balance',
    Tip           : 'Tip',
    Details       : 'Details',
    Default       : 'Default',
    Quantity      : 'Quantity',
    Status        : 'Status',
    Welcome       : 'Welcome',
    With          : 'With',
    Without       : 'Without',
    Type          : 'Type',
    Vat           : 'Vat',
    All           : 'All',
    And           : 'and',
    In            : 'in',
    RequiredField : '* Indicates a required field',
    UsersOnline   : 'Users Online',
    TestOrder     : 'TEST ORDER',
    Notification  : {
      ImportPlatformInProgress: 'Please wait while the<br>catalog is importing',
      ImportEFoodSuccess      : 'Import from E-Food has started successfully',
      ImportFoodySuccess      : 'Import from Foody has started successfully',
      ImportBoxSuccess        : 'Import from Box has started successfully',
      ImportWoltSuccess       : 'Import from Wolt has started successfully',
      ImportFagiSuccess       : 'Import from Fagi has started successfully',
      ImportGetFoodSuccess    : 'Import from Get Food has started successfully',
      FieldError              : 'Check that you have filled in all the information correctly!',
      GenericError            : 'An error occurred. Please try again.',
      DeliveryPaymentComplete : {
        Success: 'The order payment completed successfully',
        Error  : 'There was a problem when completing the order payment. Please try again!'
      },
      DeliveryPaymentConvert: {
        Success: 'The transaction payment type changed successfully',
        Error  : 'There was a problem changing the transaction payment type. Please try again!'
      },
      IssueReceipt: {
        Success: 'The fiscal document has been issued successfully',
        Error  : 'There was a problem issuing the fiscal document. Please try again!',
        Warning: {
          Title: 'Non-issuance of fiscal document',
          Order: '{receiptType}<br><strong>Order:</strong> {orderCode}<br><strong>Total:</strong> {amount}',
          Table: '{receiptType}<br><strong>Table:</strong> {table}<br><strong>Order:</strong> {tableOrder}<br><strong>Total:</strong> {amount}'
        }
      },
      ConvertReceipt: {
        Success: 'The receipt has been converted to invoice successfully',
        Error  : 'There was a problem converting the receipt to invoice. Please try again!'
      },
      CancelReceipt: {
        Success: 'The fiscal document has been canceled successfully',
        Error  : 'There was a problem canceling the fiscal document. Please try again!'
      },
      RetryReceipt: {
        Success: 'The fiscal document has been sent for transmission retry',
        Error  : 'There was a problem while sending the fiscal document for transmission retry!'
      },
      PrintReceipt: {
        Success: 'The fiscal document has been send for print',
        Error  : 'There was a problem printing the fiscal document. Please try again!'
      },
      EmailReceipt: {
        Success: 'The fiscal document has been emailed successfully',
        Error  : 'There was a problem emailing the fiscal document. Please try again!'
      },
      EmailReport: {
        Success: 'The report has been emailed successfully',
        Error  : 'There was a problem emailing the report. Please try again!'
      },
      TaxesOrphaned: {
        Both    : 'There are <strong>{categories} categories</strong> and {products} <strong>products</strong> for which no VAT category has been applied!',
        Category: 'There are <strong>{categories} categories</strong> that have no VAT category applied! | There is <strong>{categories} category</strong> that does not have a VAT category applied! | There are <strong>{categories} categories</strong> that have no VAT category applied!',
        Product : 'There are <strong>{products} products</strong> for which no VAT category has been applied! | There is <strong>{products} product</strong> that does not have a VAT category applied! | There are <strong>{products} products</strong> for which no VAT category has been applied!'
      }
    },
    WaitProgress: {
      Title: 'Please Wait'
    },
    Retry         : 'Please try again.',
    Attention     : 'Attention',
    Copy          : 'Copied Successfully',
    Exit          : 'Exit',
    ExitApp       : 'Exit Application',
    DeviceTerminal: {
      Section : 'Eft/Pos Terminal',
      Title   : 'Device Terminal',
      SubTitle: 'Set active device terminal'
    },
    LogoutDialog: {
      Title  : 'Disconnect',
      Body   : 'Do you want to Disconnect?',
      Warning: 'The Online store will stop receiving orders if no other workstation is active'
    },
    ExitAppDialog: {
      Title  : '@:Common.Misc.Exit',
      Body   : 'Do you want to exit the application?',
      Warning: '@:Common.Misc.LogoutDialog.Warning'
    }
  },

  Table: {
    Text: {
      LoadingText  : '',
      NoDataText   : 'No data',
      NoResultsText: 'No results'
    },
    Pagination: {
      From: 'from',
      To  : 'to'
    },

    Result: {
      NoDataText      : 'No records available',
      NoResultsText   : 'No records found',
      RowsPerPageItems: [10, 15, 25],
      RowsPerPageText : 'Records per page'
    }
  },

  Search: {
    Label      : 'Search',
    Icon       : 'search',
    Description: 'Search Results'
  },

  CallsQueue: {
    Toolbar: {
      Title : 'Phone calls',
      Button: {
        Title: '@:Common.Button.View all'
      }
    },
    ListView: {
      Title     : 'Calls | Call | Calls',
      NoCall    : 'There are no',
      InProgress: {
        Title: 'Calls in Progress | Call in Progress | Calls in Progress',
        Icon : 'phone_in_talk'
      },
      OnHold: {
        Title: 'Calls on Hold | Call on Hold |C alls on Hold',
        Icon : 'phone_paused'
      },
      Missed: {
        Title: 'Missed Calls | Missed Call | Missed Calls',
        Icon : 'phone_missed'
      },
      Common: {
        PotentialCustomer: 'Potential Customers',
        UnknownCustomer  : 'Unknown Customer',
        HiddenCallerID   : 'Hidden caller ID',
        NewOrder         : 'New Order',
        NewReservation   : 'New Reservation',
        CustomerTab      : 'Customer Tab'
      },
      Button: {
        Dismiss: {
          Title: '@:Common.Button.Dismiss All',
          Icon : 'delete_forever',
          Color: 'red'
        },
        DismissAndNewOrder: {
          Title: '@:Common.Button.Dismiss & New Order',
          Icon : 'add_shopping_cart'
        },
        DismissAndNewReservation: {
          Title: '@:Common.Button.Dismiss & New Reservation',
          Icon : 'mdi mdi-book-open-variant'
        }
      }
    }
  },

  ConfirmDialog: {
    Title: 'Are you sure?'
  },

  NumPadDialog: {
    Title: 'Enter Value'
  },

  EmailSelectDialog: {
    Toolbar: {
      Title   : 'Select Email',
      Subtitle: 'Enter or Select Email',
      Icon    : 'mdi-email-search-outline',
      Color   : 'blue'
    }
  },

  OnlineStatus: {
    Title: {
      Open  : 'Open',
      Closed: 'Closed'
    }
  },

  OrdersQueue: {
    Button: {
      Title: '@:Common.Button.View all'
    },
    ListView: {
      Title: {
        ToAccept  : 'to Accept',
        ToComplete: 'to Complete'
      },
      ListItem: {
        Visitor  : 'Visitor',
        Telephone: 'Tel:'
      }
    },
    Notification: {
      Title  : 'Pending Order',
      Order  : 'Order',
      Content: {
        Delay : 'You are',
        Doing : 'late to',
        Cancel: 'or CANCEL the pending order',
        Order : 'order'
      },
      Button: {
        Close : 'Close without reminder',
        Remind: 'Remind in 5"',
        View  : 'View order',
        Cancel: '@:Common.Button.Cancel @:Common.OrdersQueue.Notification.Order'
      }
    },
    AcceptOrder: {
      Title  : 'Accept Pending Order',
      Content: {
        Payment: 'Pending orders do not have a confirmed payment yet.',
        Choose : 'Choose if you want to',
        Accept : 'accept',
        Edit   : 'edit',
        Order  : 'this pending order or not.'
      }
    }
  },

  SelectDateRangeDialog: {
    Toolbar: {
      Title   : 'Select Date Range',
      Subtitle: 'Select date range from - to',
      Color   : 'primary',
      Icon    : 'date_range'
    },
    Field: {
      Staff: {
        Label: 'User',
        Hint : 'Select User',
        All  : 'All Users',
        Icon : 'supervisor_account'
      },
      Guid: {
        Label: 'Work Station',
        Hint : 'Select Work Station',
        All  : 'All Work Stations',
        Icon : 'mdi-desktop-classic'
      }
    }
  },

  FiscalDoc: [
    {
      Id    : FiscalDocTypeCodeEnum.GREEK_SALE_INVOICE,
      Code  : FiscalDocTypeEnum.INVOICE,
      Name  : 'Sales Invoice',
      Avatar: {
        Color: 'blue',
        Icon : 'mdi-receipt-text'
      }
    },
    {
      Id    : FiscalDocTypeCodeEnum.GREEK_INVOICE_CREDIT_1,
      Code  : FiscalDocTypeEnum.INVOICE_CREDIT,
      Name  : 'Credit Invoice / Associated',
      Avatar: {
        Color: 'red',
        Icon : 'mdi-receipt-text-remove'
      }
    },
    {
      Id    : FiscalDocTypeCodeEnum.GREEK_INVOICE_CREDIT_2,
      Code  : FiscalDocTypeEnum.INVOICE_CREDIT_NO,
      Name  : 'Credit Invoice / Not Associated',
      Avatar: {
        Color: 'red',
        Icon : 'mdi-receipt-text-remove'
      }
    },
    {
      Id    : FiscalDocTypeCodeEnum.GREEK_SALE_RECEIPT,
      Code  : FiscalDocTypeEnum.RECEIPT,
      Name  : 'Retail Receipt',
      Avatar: {
        Color: 'green',
        Icon : 'mdi-receipt-text'
      }
    },
    {
      Id    : FiscalDocTypeCodeEnum.GREEK_SERVICE_RECEIPT,
      Code  : FiscalDocTypeEnum.SERVICE_RECEIPT,
      Name  : 'Services Receipt',
      Avatar: {
        Color: 'green',
        Icon : 'mdi-receipt-text'
      }
    },
    {
      Id    : FiscalDocTypeCodeEnum.GREEK_RECEIPT_CREDIT,
      Code  : FiscalDocTypeEnum.RECEIPT_CREDIT,
      Name  : 'Credit Retail Receipt',
      Avatar: {
        Color: 'red',
        Icon : 'mdi-receipt-text-remove'
      }
    },
    {
      Id    : FiscalDocTypeCodeEnum.GREEK_DOCUMENT_ORDER,
      Code  : FiscalDocTypeEnum.FNB,
      Name  : 'Order Report',
      Avatar: {
        Color: 'blue-grey',
        Icon : 'mdi-receipt-text'
      }
    },
    {
      Id    : FiscalDocTypeCodeEnum.GREEK_DOCUMENT_ORDER_CANCEL,
      Code  : FiscalDocTypeEnum.FNB_CANCEL,
      Name  : 'Order Report Cancel',
      Avatar: {
        Color: 'blue-grey',
        Icon : 'mdi-receipt-text'
      }
    },
    {
      Id    : FiscalDocTypeCodeEnum.GREEK_DOCUMENT_ORDER_RETURN,
      Code  : FiscalDocTypeEnum.FNB_RETURN,
      Name  : 'Order Report Return',
      Avatar: {
        Color: 'blue-grey',
        Icon : 'mdi-receipt-text'
      }
    },
    {
      Id    : FiscalDocTypeCodeEnum.GREEK_RECEIPT_SELF_SUPPLY,
      Code  : FiscalDocTypeEnum.RECEIPT_SELF_SUPPLY,
      Name  : 'Self Supply Receipt (Sale of items)',
      Avatar: {
        Color: 'blue-grey',
        Icon : 'mdi-receipt-text'
      }
    },
    {
      Id    : FiscalDocTypeCodeEnum.GREEK_RECEIPT_SELF_SUPPLY_CREDIT,
      Code  : FiscalDocTypeEnum.RECEIPT_SELF_SUPPLY_CREDIT,
      Name  : 'Credit Self Supply Receipt (Sale of items)',
      Avatar: {
        Color: 'blue-grey',
        Icon : 'mdi-receipt-text'
      }
    },
    {
      Id    : FiscalDocTypeCodeEnum.GREEK_RECEIPT_SELF_USE,
      Code  : FiscalDocTypeEnum.RECEIPT_SELF_USE,
      Name  : 'Self Use Receipt (Sale of services)',
      Avatar: {
        Color: 'blue-grey',
        Icon : 'mdi-receipt-text'
      }
    },
    {
      Id    : FiscalDocTypeCodeEnum.GREEK_RECEIPT_SELF_USE_CREDIT,
      Code  : FiscalDocTypeEnum.RECEIPT_SELF_USE_CREDIT,
      Name  : 'Credit Self Use Receipt (Sale of services)',
      Avatar: {
        Color: 'blue-grey',
        Icon : 'mdi-receipt-text'
      }
    }
  ],

  Map: {
    Title    : 'Map',
    Satellite: 'Satellite'
  },

  ColorPicker: {
    Error: {
      InvalidColor: 'It\'s not a valid color code!'
    }
  },

  Error: {
    Mandatory: 'The field is mandatory',
    Required : 'The field is required',
    Generic  : 'An error occurred. Please try again later.',
    Offline  : {
      Icon    : 'mdi-wifi-off',
      Title   : 'No Internet Connection',
      Subtitle: 'Your internet connection is currently not available, please check or try again.',
      Button  : 'Try Again',
      Electron: {
        Title       : 'Printing Orders NOT Available!',
        WorkStations: 'Offline Work Stations'
      }
    }
  }
}
